import React, { useEffect } from 'react';
import Modal from '../../atoms/modal/view';
import { associateSubscription } from '../../../usecases/subscriptions-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import './style.css';
import CardToken from '../cardToken/view';

const PaymentModal = ({ id = 'payment', isOpen }) => {
    useEffect(() => {
        if (isOpen) {
            dispatchCustomEvent('modal' + id, { eventKey: id });
        }
    }, [isOpen]);

    const handlePayment = async (cardToken) => {
        associateSubscription({
            card_token_id: cardToken.id,
        }).then(() => {
            dispatchCustomEvent('popup', {
                message: '¡Suscripción activada con éxito!',
                type: 'success'
            });
            dispatchCustomEvent('close-' + id + '-modal');
        }).catch((err) => {
            const errorMsg = err?.response?.data?.message || err?.message || 'Error al activar la suscripción';
            dispatchCustomEvent('popup', {
                message: errorMsg,
                type: 'error'
            });
        }).finally(() => {
            dispatchCustomEvent("loading-btn-token", null)
        })
    };

    return (
        <Modal id={id}>
            <div className="payment-modal-container">
                <header className="payment-modal-header">
                    <h2 className="payment-modal-title">Activa tu Suscripción</h2>
                    <p className="payment-modal-subtitle">
                        Completa tus datos de pago de forma segura para continuar utilizando easypos.
                    </p>
                </header>

                <CardToken onsubmit={handlePayment} />
            </div>
        </Modal>
    );
};

export default PaymentModal;
